/**
 * Paint a freshly resized canvas the stage's own ground.
 *
 * Both renderers draw into an opaque context (`alpha: false`), and setting a
 * canvas's size clears it — to opaque BLACK, not to transparent, so the
 * stage's `--canvas-edge` background behind it never shows. The frame that
 * repaints it is the next animation frame at the soonest (a `ResizeObserver`
 * runs after this frame's callbacks), and during a window drag every frame is
 * such a frame. On the night field black is a shade off the ground and nobody
 * saw it; on paper it was a black slab. So the cleared canvas takes the colour
 * the stage would have shown through a transparent one, read from the same
 * token, until the renderer draws over it.
 *
 * Read per resize rather than cached: a resize is rare, and a cached colour is
 * a second copy of the palette that a theme change would leave behind.
 */
export function groundAfterResize(canvas: HTMLCanvasElement, ctx: CanvasRenderingContext2D) {
  const ground = getComputedStyle(canvas).getPropertyValue('--canvas-edge').trim()
  if (!ground) return
  ctx.fillStyle = ground
  ctx.fillRect(0, 0, canvas.width, canvas.height)
}
